export const LOYALTY_SUBSCRIPTION_LOAD = 'LOYALTY_SUBSCRIPTION_LOAD';
export const LOYALTY_SUBSCRIPTION_PAGE_REQUEST =
  'LOYALTY_SUBSCRIPTION_PAGE_REQUEST';
export const LOYALTY_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS =
  'LOYALTY_SUBSCRIPTION_FEATURE_PRICE_PER_MONTHS';
export const LOYALTY_SUBSCRIPTION_FEATURE_PRICE =
  'LOYALTY_SUBSCRIPTION_FEATURE_PRICE';
export const LOYALTY_SUBSCRIPTION_SUBSCRIPTION_STATUS =
  'LOYALTY_SUBSCRIPTION_SUBSCRIPTION_STATUS';
export const LOYALTY_SUBSCRIPTION_PAGE_ON_LOADING =
  'LOYALTY_SUBSCRIPTION_PAGE_ON_LOADING';

export const LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS =
  'LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE_PER_MONTHS';
export const LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE =
  'LOYALTY_SUBSCRIPTION_SET_FEATURE_PRICE';
export const LOYALTY_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE =
  'LOYALTY_SUBSCRIPTION_SET_PENDING_PAYMENT_MESSAGE';
export const LOYALTY_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE =
  'LOYALTY_SUBSCRIPTION_SET_PENDING_OUTLET_MESSAGE';
export const LOYALTY_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL =
  'LOYALTY_SUBSCRIPTION_SET_SUBSCRIPTION_DETAIL';
export const LOYALTY_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT =
  'LOYALTY_SUBSCRIPTION_SET_CURRENT_OUTLET_COUNT';
export const LOYALTY_SUBSCRIPTION_SET_OUTLETS =
  'LOYALTY_SUBSCRIPTION_SET_OUTLETS';
export const LOYALTY_SUBSCRIPTION_SET_BUTTON_MESSAGE =
  'LOYALTY_SUBSCRIPTION_SET_BUTTON_MESSAGE';

export const LOYALTY_SUBSCRIPTION_GET_BILLINGS =
  'LOYALTY_SUBSCRIPTION_GET_BILLINGS';
export const LOYALTY_SUBSCRIPTION_GET_OUTLETS =
  'LOYALTY_SUBSCRIPTION_GET_OUTLETS';

export const LOYALTY_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL =
  'LOYALTY_SUBSCRIPTION_SHOW_DETAIL_TRANSACTION_MODAL';
export const LOYALTY_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL =
  'LOYALTY_SUBSCRIPTION_HIDE_DETAIL_TRANSACTION_MODAL';
export const LOYALTY_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL =
  'LOYALTY_SUBSCRIPTION_SHOW_PAYMENT_GATEWAY_ERROR_MODAL';
export const LOYALTY_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL =
  'LOYALTY_SUBSCRIPTION_HIDE_PAYMENT_GATEWAY_ERROR_MODAL';

export const LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_BASIC_BUTTON =
  'LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_BASIC_BUTTON';
export const LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_PRO_BUTTON =
  'LOYALTY_SUBSCRIPTION_SET_SUBSCRIBE_PRO_BUTTON';
export const LOYALTY_SUBSCRIPTION_SUBSCRIBE_BASIC =
  'LOYALTY_SUBSCRIPTION_SUBSCRIBE_BASIC';
export const LOYALTY_SUBSCRIPTION_SUBSCRIBE_PRO =
  'LOYALTY_SUBSCRIPTION_SUBSCRIBE_PRO';
export const LOYALTY_SUBSCRIPTION_START_PRO_TRIAL =
  'LOYALTY_SUBSCRIPTION_START_PRO_TRIAL';
